import React from 'react';
import { MessageSquarePlus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function FloatingFeedbackButton() {
  const location = useLocation();
  const { user } = useAuth();

  // Don't show the button if user is not logged in or on the feedback page
  if (!user || location.pathname === '/feedback') {
    return null;
  }

  return (
    <Link
      to="/feedback"
      className="fixed right-[-150px] top-1/2 -translate-y-1/2 z-[100] bg-orange-600 text-white px-4 py-3 rounded-l-lg shadow-lg hover:bg-orange-700 transition-all duration-200 hover:right-[-145px] transform -rotate-90 origin-left"
      title="Submit Feedback"
    >
      <div className="flex items-center space-x-2">
        <MessageSquarePlus className="h-5 w-5" />
        <span className="text-sm font-medium whitespace-nowrap">Submit Feedback</span>
      </div>
    </Link>
  );
}